import { useEffect } from "react";
import { useAppContext } from "./useAppContext";
import { useConfigs } from "./useConfigs";

export const useAutoSave = () => {
	const { editor, client, networkMonitor, context, platform } = useAppContext();

	const [[autoSaveIntervalInSeconds], isConfigsPending] = useConfigs([
		{
			key: "Editor.AutoSaveIntervalInSeconds",
		},
	]);

	// this is done here because providing a default at desctructuring only works on undefned values, not null
	const autoSaveIntervalWithDefault = autoSaveIntervalInSeconds || 300;

	useEffect(() => {
		if (!isConfigsPending) {
			const autosave = new eXpress.AutoSave(
				{
					commandManager: editor.commandManager,
					client,
					logger: editor.logger,
					saveDefinitionAsActiveAsync: editor.saveDefinitionAsActiveAsync.bind(editor),
					watchPageVisibility: platform.pageVisibility.watchPageVisibility,
					getIsOnline: networkMonitor.getIsOnline.bind(networkMonitor),
					broadcaster: editor.broadcaster,
				},
				() =>
					eXpress.AccountId.isNotEmpty(context.account.id) &&
					!editor.hasPendingUploads(true),
			);

			autosave.start(+autoSaveIntervalWithDefault);

			return autosave.dispose.bind(autosave);
		}

		return undefined;
	}, [
		autoSaveIntervalWithDefault,
		client,
		context,
		editor,
		platform.pageVisibility.watchPageVisibility,
		isConfigsPending,
		networkMonitor,
	]);
};
